/**
 * Determines the appropriate loader to display based on the current application state.
 * It checks if the user is on the login page or logged in and toggles the visibility
 * of the bootstrap loader and the load screen accordingly.
 *
 * @return This method does not return a value.
 */

export function showCorrectLoader(): void {
    const isLoginPage = window.location.hash.startsWith('#/login');
    const isLoggedIn = !!sessionStorage.getItem('a9.authData');
    const bootstrapLoader = document.getElementById('bootstrapLoader');
    const loadScreen = document.getElementById('loadScreen');
    if (!isLoggedIn) {
        if (bootstrapLoader) bootstrapLoader.style.display = '';
        if (loadScreen) loadScreen.style.display = 'none';
    } else if (isLoginPage) {
        if (bootstrapLoader) bootstrapLoader.style.display = '';
        if (loadScreen) loadScreen.style.display = 'none';
    } else {
        if (bootstrapLoader) bootstrapLoader.style.display = 'none';
        if (loadScreen) loadScreen.style.display = '';
    }
}
